import { formatPrice } from 'utils/common';

interface IMenuItemProps {
  image: string;
  name: string;
  price: number;
  description?: string;
}

const MenuItem = (props: IMenuItemProps) => {
  return (
    <div className="flex items-center gap-x-2 cursor-pointer">
      <img
        src={props.image}
        alt="menu item"
        className="object-cover w-[64px] h-[64px] transition duration-300 hover:scale-[2.5]"
      />

      <div className="flex flex-col w-full">
        <div className="flex items-center gap-2">
          <div className="flex items-center gap-2 w-full">
            <h2 className="text-primary font-bold w-fit xl:max-w-[375px] md:max-w-[200px] max-w-[100px]">
              {props.name}
            </h2>
            <div className="border rounded-none border-dashed border-grey-g-100 mr-4 flex-1"></div>
          </div>

          <span className="text-primary font-semibold w-fit">{formatPrice(props.price)}</span>
        </div>

        {props.description && (
          <p className="text-[12px] text-grey-100 line-clamp-2 font-bold">{props.description}</p>
        )}
      </div>
    </div>
  );
};

export default MenuItem;
